$(function() {
	if (!$body.hasClass('page-special-offers'))
		return;

    var initSpecials = function() {
        var specialsImages = $('.special_listing_item');
        // var specialsLinks = $('.gallery_link');
        var filteredSpecialsImages = specialsImages;
        var categories = $('#specials_categories a');
        var activeCategory = window.location.href.match(/#([^/&]+)/);
        let location;

        var updateUrl = function(url, category) {

            if (category && category != '#')
                url += category;

            if (url != window.location.href)
                window.history.pushState('', '', url);
        

        }
        var filterCategory = function(element) {
            specialsImages.removeClass('appear');
            if (element) {
                element = $(element);
                activeCategory = element.attr('href').slice(1);
            }

            filteredSpecialsImages = specialsImages.filter('[cat=' + activeCategory + ']');

            filteredSpecialsImages.each(function() {
                var image = $(this);
                setTimeout(function() {
                    image.addClass('delayed_loaded');
                }, 1000);
            })

            setTimeout(function() {
                filteredSpecialsImages.addClass('appear');
            }, 200);

            updateUrl(document.location.pathname + '#' + activeCategory);
        }

        var currentUrl = URI(document.location);
        if (currentUrl.hash()) {
            var currentlySelected = categories.filter('[href="' + currentUrl.hash() + '"]');

            if (currentlySelected.length) {
                currentlySelected.trigger('click')
            } else {
                categories.eq(0).trigger('click');
            }
        } else {
            categories.eq(0).trigger('click');
        }
            
        categories.click(function() {
            categories.removeClass('active_category');
            $(this).addClass('active_category');
            filterCategory(this);
        });

        function onLoaded() {
            if(currentUrl.hash() == '#' + activeCategory) {
                updateUrl(document.location.pathname + '#' + activeCategory);
            } else {
                activeCategory = categories.eq(0).attr('cat')
                updateUrl(document.location.pathname + '#' + activeCategory);
            }
            var currentCat = '#' + activeCategory
            categories.each(function() {
                var cat = $(this).attr('href')
                if(cat != currentCat && currentUrl.hash() == cat) {
                    categories.removeClass('active_category')
                    $(this).addClass('active_category')
                    filterCategory(this)
                }
                if(cat == currentCat) {
                    $(this).addClass('active_category')
                    filterCategory(this)
                }
            })
        }

        $(window).load(onLoaded)

        if (document.readyState == 'complete') {
            onLoaded()
        }
    }

    // $.get('/api/geolocate', function(response) {
    //     location = response
        // filteredSpecialsImages.each(function() {
        //     var image = $(this);
        //     if(location.state != "CA") {
        //         if(image.data('location') == "CA") {
        //             image.removeClass('appear') 
        //         }
        //     } else {
        //         image.addClass('appear');
        //     }
        //     setTimeout(function() {
        //         image.addClass('delayed_loaded');
        //     }, 1000);
        // })
        
    // });
    // console.log(location)
    var waitForReady = setInterval(function() {
        if ($('body').hasClass('ready') || $('body').hasClass('ready')) {
            initSpecials();
            clearInterval(waitForReady);
        }
    }, 80);

});